<!-- JobItemSelect.vue -->
<template>
  <div class="text-text1">
    <div v-if="localItemList.length > 0">
      <div class="flex items-center mb-2">
        <p class="label_css mb-0">Items list:</p>
        <span @click="itemSelect = true" class="text-primary cursor-pointer ml-2 heading-6">Add/Edit</span>
      </div>
      <div class="mb-3 ml-6">
        <div
          class="p-3 mb-2 border border-gray2 rounded-lg bg-white cursor-pointer"
          v-for="(data, index) in localItemList"
          :key="index"
          @click="itemSelect = true"
        >
          <div class="text-text1 text-sm font-bold mb-2">
            <p class="heading-6">{{ data.itemName }}</p>
          </div>
          <div class="text-text2 flex justify-between mb-2 items-center">
            <p class="w-32 sm:w-72 heading-7">Price: {{ data.itemPrice | amountOnlyNumber }}</p>
            <p class="w-32 sm:w-72 heading-7">Qty: {{ data.itemQty }} <span class="pl-4" v-if="data.isTaxable">Taxed</span></p>
            <p class="font-bold heading-6">Total: {{ data.itemAmount | amountOnlyNumber }}</p>
          </div>
          <div class="my-2 border-t border-gray-300"></div>
          <div class="text-text2 mb-0">
            <p class="heading-7 text-gray4" style="max-width: 80%; word-wrap: break-word;">{{ data.itemDescription }}</p>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="flex items-center">
      <span @click="itemSelect = true" class="text-primary font-bold cursor-pointer">
        + Add Item to this Job
      </span>
      <InfoTooltip tooltipText="Item list will show up so that you can easily create invoice from it" position="top" class="ml-2 mt-2"/>
    </div>

    <!-- This is now correctly bound -->
    <ItemSelection
      v-if="itemSelect"
      :itemsSelected="localItemList"
      @update:itemsSelected="localItemList = $event"
      @close="itemSelect = false"
    />
  </div>
</template>

<script>
import ItemSelection from '@/View/setting/items/components/ItemSelection.vue'
import InfoTooltip from '@/View/components/InfoTooltip.vue'

export default {
  name: 'JobItemSelect',
  components: { ItemSelection, InfoTooltip },
  props: {
    itemList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      itemSelect: false,
      localItemList: [],
      isUpdatingFromProp: false  // Guard flag to prevent infinite loop
    }
  },
  watch: {
    itemList: {
      handler(newVal) {
        // Prevent circular updates
        this.isUpdatingFromProp = true
        this.localItemList = Array.isArray(newVal) ? [...newVal] : []
        this.$nextTick(() => {
          this.isUpdatingFromProp = false
        })
      },
      immediate: true,
      deep: true
    },
    localItemList: {
      handler(newVal) {
        // Only emit if this change didn't come from the prop watcher
        if (!this.isUpdatingFromProp) {
          this.$emit('update:itemList', [...newVal])
        }
      },
      deep: true
    },
    itemSelect: {
      handler(newVal) {
        // Notify parent when popup opens/closes
        this.$emit('popupStateChanged', newVal)
      }
    }
  }
}
</script>